var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publicity-top"},[_c('publicity-header',{attrs:{"project":"publicity-green-report-header"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }